import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { GenericPayloadType, SocketMessagePayload } from '@ezugi/types';

type InitialState = {
  reconnect: number,
  connected?: boolean,
};

const initialState: InitialState = {
  reconnect: 0,
  connected: false,
};

type SocketRequestPayload = { fromReconnectToServer?: boolean } | undefined;

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    message(_state, _action: PayloadAction<SocketMessagePayload>) {},
    request(_state, _action: PayloadAction<SocketRequestPayload>) {},
    success(state) {
      return {
        ...state,
        connected: true,
        reconnect: 0,
      };
    },
    failure(state) {
      return {
        ...state,
        connected: false,
      };
    },
    moveTable() {},
    reconnect(state) {
      return {
        ...state,
        connected: true,
        reconnect: state.reconnect + 1,
      };
    },
    error(_state, _action: PayloadAction<GenericPayloadType>) {},
    close(state) {
      return {
        ...state,
        connected: false,
      };
    },
    send(_state, _action: PayloadAction<GenericPayloadType>) {},
  },
});

export const socketActions = socketSlice.actions;
export default socketSlice.reducer;
